import type { Task, Project, Subtask, Sprint, TaskStatus, TaskPriority } from '@/lib/types'
import type { StatusOf } from '@/lib/dev-sprint'

export interface TeamMember {
  email: string
  name: string
  username: string | null
}

export interface BoardData {
  sprints: Sprint[]
  projects: Project[]
  tasks: Task[]
  subtasks: Subtask[]
  team: TeamMember[]
}

export interface Filters {
  dev: string | null // username (lowercased match)
  project: string | null // project id
  status: TaskStatus | null
  priority: TaskPriority | null
  risk: boolean // hanya task at-risk
}

export const EMPTY_FILTERS: Filters = {
  dev: null,
  project: null,
  status: null,
  priority: null,
  risk: false,
}

/** Konteks terhitung yang dibagi ke semua view /dev. */
export interface DevDerived {
  statusOf: StatusOf
  subsByTask: Map<string, Subtask[]>
  projById: Map<string, Project>
  todayISO: string
  isProjectBlocked: (projectId: string) => boolean
  overloadedUsers: Set<string>
}
